import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { ArrowLeft, Search } from 'lucide-react'
import { Button } from '@/ui/components/common/Button'

/** Shown when a public investigation URL matches nothing (unknown slug/UUID or removed article). */
export function InvestigationNotFound() {
  const { t } = useTranslation()
  return (
    <div className="read-article mx-auto grow w-full max-w-[100rem] bg-card px-8 py-16 text-center">
      <Search className="h-12 w-12 mx-auto mb-4 text-muted-foreground opacity-40" />
      <h1 className="font-serif text-3xl font-bold mb-2">
        {t('investigation_detail.not_found_title')}
      </h1>
      <p className="text-muted-foreground mb-6">{t('investigation_detail.not_found_body')}</p>
      <Link to="/investigations">
        <Button variant="outline">
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('common.back')}
        </Button>
      </Link>
    </div>
  )
}
